module.exports = __webpack_public_path__ + "static/author-1-e9f3b3b24015d77b09b5c360c192c12a.jpg";